




import { Component, Mixins } from "vue-property-decorator";
import { InjectedObjectEvidenceHtmlPresentableMixin } from "./mixins";

@Component
export default class InjectedObjectEvidenceHtmlContentDrawer extends Mixins(InjectedObjectEvidenceHtmlPresentableMixin) {}
